<div class="p-4 flex flex-col gap-3" *transloco="let t; read 'pricing.transactions'">

  <!--  t(pricing.transactions.invoiceNumber, pricing.transactions.name, pricing.transactions.dateOfDelivery)  -->
  <ngx-datatable
    [messages]="{emptyMessage: 'no_data_in_table' | transloco}"
    class="material"
    columnMode="flex"
    [loadingIndicator]="!transactions"
    [rows]="transactions"
    [rowHeight]="50"
    [headerHeight]="50">
    <ngx-datatable-column
      *ngFor="let column of columns"
      [flexGrow]="column.flexGrow"
      [name]="t(column.translationKey)"
      [prop]="column.prop">
    </ngx-datatable-column>

    <ngx-datatable-column
      [flexGrow]="1"
      [name]="t('dateOfDelivery')"
      prop="dateOfDelivery">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        {{value | date:'dd.MM.yyyy. HH:mm'}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      *ngIf="showPlantName"
      [flexGrow]="2"
      [name]="t('projectName')"
      prop="projectName">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        {{value}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [flexGrow]="1"
      [name]="t('totalAmount')"
      prop="totalAmount">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        {{value}} {{row.currency}}
      </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column
      [flexGrow]="1"
      [name]="t('status')"
      prop="paymentStatus">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <psc-payment-status-text [status]="value"></psc-payment-status-text>
      </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column
      [flexGrow]="1"
      [name]="t('download')"
      prop="paymentId">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <psc-loader size="small" *ngIf="loadingTransactionBill[value]"></psc-loader>
        <mat-icon
          *ngIf="!loadingTransactionBill[value]"
          (click)="downloadBill(value, row['dateOfDelivery'])"
          class="text-blue1 hover:text-blue2 cursor-pointer">download
        </mat-icon>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>
</div>
